var icons = {
    markerBlue : "/images/markerclusterer/circle-navy.png",
    markerOrange : "/images/markerclusterer/circle-orange.png"
};

function generateCustomMarker(flight) {
	var text = '<div id="marker-product-content" >'
			+ '<div class="marker-product-item ">' + '<p class="marker-product-price '+ flight.markerClass + '"><strong>'
			+ currencyFormatZero(flight.amount) + '</strong></p>' + '</div>'
        	+ '<div id="marker-product-title">'+ flight.toAirportInfo.cityName +'</div>'
			+
        + '</div>';
	return text;
}

function CustomMarker(flight, latlng) {
	this.visible = true;
	this.latlng = latlng;
	this.flight = flight;
	this.setMap(app.map);
	var self = this;
	this.infowindow = new google.maps.InfoWindow({
		content : self.flight.toAirportInfo.name
	});
}

CustomMarker.prototype = new google.maps.OverlayView();

CustomMarker.prototype.draw = function() {
	var self = this;
	var div = this.div;
	if (!div) {
		div = this.div = $(generateCustomMarker(this.flight))[0];
		google.maps.event.addDomListener(div, "click", function(event) {

			// communicate with vue
            app.selectedToAirport = self.flight;
            app.searchAllFlights();
		});
		var panes = this.getPanes();
		panes.overlayImage.append(div);
	}
	var point = this.getProjection().fromLatLngToDivPixel(this.latlng);
	if (point) {
		div.style.left = (point.x - 30) + 'px';
		div.style.top = (point.y - 10) + 'px';
	}
};

CustomMarker.prototype.hide = function() {
	if (this.div) {
		this.div.style.visibility = 'hidden';
	}
};

CustomMarker.prototype.show = function() {
	if (this.div) {
		this.div.style.visibility = 'visible';
	}
}

CustomMarker.prototype.remove = function() {
	if (this.div) {
		this.div.parentNode.removeChild(this.div);
		this.div = null;
	}
	this.setMap(null)
};

CustomMarker.prototype.getPosition = function() {
	return this.latlng;
};

var app = new Vue({
	el : '#wrap',
	data : {
		markers: [],
		map : null,
        searchData: null,
		fromAirport: null,
        minPrices: [],
		CustomMarker : '',
		currency: '',
		selectedToAirport: null,
        extraPriceListDeparture: [],
		extraPriceListReturn: [],
		fromAirportMarker: null,
        priceLoading: false,
		search: null,
		suggestedHotels:[]
    },
	created : function() {
		google.maps.event.addDomListener(window, 'load', this.initialize)
	},
	methods : {

		initialize : function() {
			var vm = this;
			var latlng = new google.maps.LatLng(39.305, -76.617);
			var properties = {
				zoom : 3,
				mapTypeId : 'roadmap',
				center : latlng,
				mapTypeControl : false,
				gestureHandling : "greedy",
				streetViewControl : false,
				styles : [
                    {
                        "featureType": "administrative",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.country",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    }]
			};

			this.map = new google.maps.Map(document.getElementById('map_canvas'), properties);
            google.maps.event.addListenerOnce(this.map, 'tilesloaded', function(){
				vm.$refs.minPriceMapSearch.getFromCookie();
            });

		},
		setCenter : function() {
			var vm = this;


			if (!this.fromAirport && !!this.fromAirportMarker){
				this.fromAirportMarker.setMap(null);
				this.fromAirportMarker = null;
				return;
			}
            var markerPos = new google.maps.LatLng(vm.fromAirport.lat, vm.fromAirport.lon);

            if (this.fromAirportMarker == null){
                this.fromAirportMarker = new google.maps.Marker({
                    map : vm.map,
                    icon: icons.markerBlue,
                });
			}
			this.fromAirportMarker.setPosition(markerPos);

			vm.map.setCenter(new google.maps.LatLng(vm.fromAirport.lat, vm.fromAirport.lon));
            vm.map.setZoom(6);
		},
		drawMap : function() {
			var vm = this;
			vm.minPrices.forEach(function(el, key) {
				
				if (el.legCount == 1){
                    el.markerClass='marker-product-nonstop';
				}
				else if(el.legCount == 2){
                    el.markerClass='marker-product-two-leg';
				}
                else if(el.legCount > 2){
                    el.markerClass='marker-product-multi-leg';
                }

				var toAirportInfo = el.toAirportInfo;

				var markerPos = new google.maps.LatLng(toAirportInfo.lat, toAirportInfo.lon);
				var marker = new CustomMarker(el, markerPos);
				vm.markers.push(marker);
			});
		},
        searchAllFlights: function () {
			this.getMinPrices();
        },
        filterResult: function (filteredMinPrices) {
			var toAirports = filteredMinPrices.map(function (minPrice) {
				return minPrice.toAirport;
            });

			this.markers.forEach(function (marker) {
				if(!toAirports.includes(marker.flight.toAirport)){
					marker.hide();
				}
				else{
					marker.show();
				}
			})
        },
        getImageUrl : function(hotel) {
        	if(hotel.imageUrl) {
        		return hotel.imageUrl
        	}else {
        		return '/images/default-photo.png';
        	}
        },
        getHotelSearchLink: function(hotel){
        	return URL_MAPPING.resolveUrl('/hotelDetailSearch')+hotel.url;
        },
        getHotelPrice: function(hotel) {
          return currencyFormatZero(hotel.price);	
        },
        getHotelClass: function(hotel){
        	return 'hotel-star star'+hotel.starNumber;
        },
		getMinPrices: function () {
			var vm = this;
            $.ajax(
                {
                    type : 'POST',
                    url : '/getSearchMinPriceDataList',
                    dataType : 'json',
                    async:true,
                    data : {
                        departureStart : vm.search.fromDate,
                        departureEnd : vm.search.toDate,
                        returnStart : vm.search.fromDate,
                        returnEnd : vm.search.toDate,
                        fromAirportId: vm.fromAirport.code,
                        toAirportId : vm.selectedToAirport.toAirportInfo.code
                    },
                    success : function(response) {
                        if(response.success) {
                        	var data = response.departureMinPrices;

                        	data.forEach(function (flight) {
                        		var date = new Date(flight.date)
								flight.textDate = $.datepicker.formatDate("dd.mm.yy", date);
                                flight.textPrice = parseFloat(flight.price).toFixed(2) + " " + flight.currency;
                                var searchDate = flight.textDate = $.datepicker.formatDate("yy-mm-dd", date);
                                var searchUrl = URL_MAPPING.resolveUrl('/searchFlights');
                                flight.searchLink = searchUrl + '/' + vm.fromAirport.code + '-' + vm.selectedToAirport.toAirportInfo.code + '/' + searchDate  + '/1-0-0/ALL'
                            });
							vm.extraPriceListDeparture = data;

                            data = response.returnMinPrices;

                            data.forEach(function (flight) {
                                var date = new Date(flight.date)
                                flight.textDate = $.datepicker.formatDate("dd.mm.yy", date);
                                flight.textPrice = parseFloat(flight.price).toFixed(2) + " " + flight.currency;
                                var searchDate = flight.textDate = $.datepicker.formatDate("yy-mm-dd", date);
                                var searchUrl = URL_MAPPING.resolveUrl('/searchFlights');
                                flight.searchLink = searchUrl + '/' + vm.selectedToAirport.toAirportInfo.code + '-' + vm.fromAirport.code + '/' + searchDate  + '/1-0-0/ALL'
                            });
                            vm.extraPriceListReturn = data;
                        }
                    }
                })
                .then(function() {
                });
            vm.suggestedHotels='';
            $.ajax({
        		url : "/suggestedHotelsMap",
        		dataType : 'json',
                async:true,
        		data :{
        			arrivalCity : vm.selectedToAirport.toAirportInfo.cityName,
        			checkin : vm.selectedToAirport.fromDate,
        			checkout : vm.selectedToAirport.returnDate,
					airportCode: vm.selectedToAirport.toAirportInfo.code
        		},
        		success : function(data) {
        			if(data.suggestedHotels){
        				vm.suggestedHotels=data.suggestedHotels;
        				
        			} else {
        				vm.suggestedHotels='';
        			}
        		},
        		error : function(err){
        			vm.suggestedHotels='';
        		}
        	});
        },
		setPriceLoading: function(load){
			this.priceLoading = load;
		},
        closePriceList:function(){
            this.selectedToAirport = null;
            this.extraPriceListDeparture = [];
            this.extraPriceListReturn = [];
		}
	},
	computed: {
		hasFlight: function(){
			return typeof this.selectedToAirport !== 'undefined' && this.selectedToAirport != null;
		},
	},
	watch: {
        selectedToAirport: {
        	deep: true,
			handler: function(){
        		if (typeof this.selectedToAirport !== 'undefined' && this.selectedToAirport != null){
                    var searchUrl = URL_MAPPING.resolveUrl('/searchFlights');
                    var from = this.selectedToAirport.fromAirport + '-' + this.selectedToAirport.toAirport + '/' + this.selectedToAirport.fromDate;
                    var to = this.selectedToAirport.toAirport + '-' + this.selectedToAirport.fromAirport + '/' + this.selectedToAirport.returnDate;
                 	this.selectedToAirport.searchLink = searchUrl + '/' + from + '/' + to + '/1-0-0/ALL';
                    this.selectedToAirport.textPrice = parseFloat(this.selectedToAirport.amount).toFixed(2) + " " + this.selectedToAirport.currency;

                }
			}
		},
        searchData:{
        	deep: true,
			handler: function () {
        		this.markers.forEach(function (marker) {
        			marker.remove();

				});

        		this.selectedToAirport = null;
				this.extraPriceListDeparture = [];
				this.extraPriceListReturn = [];
        		this.markers = [];

        		this.minPrices = this.searchData.minPrices;
        		this.fromAirport = this.searchData.fromAirport;
				this.search = this.searchData.search
				this.setCenter();
				this.drawMap();
            }
		}
	}

});